import { render, staticRenderFns } from "./DrinkingAgeOverlay.vue?vue&type=template&id=646d9ebb&scoped=true"
import script from "./DrinkingAgeOverlay.vue?vue&type=script&lang=js"
export * from "./DrinkingAgeOverlay.vue?vue&type=script&lang=js"
import style0 from "./DrinkingAgeOverlay.vue?vue&type=style&index=0&id=646d9ebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d9ebb",
  null
  
)

export default component.exports